import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Icon,
  IconButton,
  Menu,
  MenuList,
  MenuItem,
  ListItemText,
  ListSubheader,
  Checkbox,
  Tooltip,
  Fab,
} from '@material-ui/core';
import { getForms } from '@pingum/app-state-management/form/actions';
import styles from './styles';

export class StatusSettingsHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      includeArchived: props.includeArchived,
    };

    this.handleIncludeArchivedChanged = this.handleIncludeArchivedChanged.bind(this);
    this.handleSettingsClick = this.handleSettingsClick.bind(this);
    this.handleSettingsClose = this.handleSettingsClose.bind(this);
  }

  handleIncludeArchivedChanged() {
    this.setState((prevState) => ({ includeArchived: !prevState.includeArchived }), () => {
      this.props.getForms(this.state.includeArchived);
    });
  }

  handleSettingsClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleSettingsClose() {
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      onAddForm,
      isAddingForm,
    } = this.props;
    const {
      anchorEl,
      includeArchived,
    } = this.state;
    return (
      <div style={styles.formSettingsTitleContainer}>
        <h3
          style={styles.formSettingsTitle}
          className="event-form-page-title"
        >
          Forms
        </h3>
        <div style={styles.formSettingsActionsContainer}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={onAddForm}
            disabled={isAddingForm}
            size="medium"
            style={styles.addButton}
          >
            <Tooltip title="Add New Form">
              <Icon>add</Icon>
            </Tooltip>
          </Fab>
          <Tooltip title="More Actions" id="status-more-actions-tooltip">
            <IconButton
              onClick={this.handleSettingsClick}
              className="more-actions-button"
            >
              <Icon>more_vert</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleSettingsClose}
          >
            <ListSubheader>
              More actions
            </ListSubheader>
            <MenuList>
              <MenuItem
                onClick={this.handleIncludeArchivedChanged}
                button
                id="include-archived-statuses-button"
              >
                <Checkbox
                  disableRipple
                  checked={includeArchived}
                />
                <ListItemText primary="Include archived" />
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    );
  }
}

StatusSettingsHeaderComponent.propTypes = {
  getForms: PropTypes.func,
  includeArchived: PropTypes.bool,
  onAddForm: PropTypes.func,
  isAddingForm: PropTypes.bool,
};

StatusSettingsHeaderComponent.defaultProps = {
  getForms: () => {},
  includeArchived: false,
  onAddForm: () => {},
  isAddingForm: false,
};

export const mapStateToProps = (state) => ({ includeArchived: state.form.includeArchived });

export const mapDispatchToProps = (dispatch) => (
  { getForms: (includeArchived) => dispatch(getForms(includeArchived)) });

export default connect(
  null,
  mapDispatchToProps,
)(StatusSettingsHeaderComponent);
